import React from "react";
// ANT DESIGN COMPONENTS
import { Input } from "antd";
// INTERFACES
import { FormularyType } from "../../../interfaces/Wizard.interface";

export default function FormInputText({
  inputValue,
  inputOnChange,
  inputLabelName,
  inputVariableName,
  isRequired,
  disabledInput,
  formularyType = FormularyType.PAGE,
  placeholder = undefined,
}: {
  inputValue: string;
  inputLabelName: string;
  inputOnChange: (newValue: string, inputName: string) => void;
  inputVariableName: string;
  isRequired: boolean;
  disabledInput: boolean;
  formularyType?: FormularyType;
  /** Shown while the input is empty. */
  placeholder?: string;
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <>
      {formularyType === FormularyType.WIZARD ? (
        <div>
          <div className="generalStyles__inputFlexNameLarge">
            {isRequired ? (
              <span className="generalStyles__inputFlexRequired">*</span>
            ) : (
              <span style={{ marginLeft: "8px" }} />
            )}
            <span className="drawer__text">{inputLabelName}</span>
          </div>
          <div
            className="generalStyles__width100"
            style={{
              marginTop: "9px",
            }}
          >
            <Input
              className="generalStyles__input"
              value={inputValue}
              size="large"
              onChange={(event: React.FormEvent<HTMLInputElement>) => {
                inputOnChange(event.currentTarget.value, inputVariableName);
              }}
              disabled={disabledInput}
              placeholder={placeholder}
            />
          </div>
        </div>
      ) : (
        <>
          <div className="col-md-12 mt-3">
            <div className="generalStyles__flex">
              <div className="generalStyles__inputFlexNameLarge">
                {isRequired ? (
                  <span className="generalStyles__inputFlexRequired">*</span>
                ) : (
                  <span style={{ marginLeft: "8px" }} />
                )}
                <span className="drawer__text">{inputLabelName}</span>
              </div>
              <div className="generalStyles__width100">
                <Input
                  className="generalStyles__input"
                  size="small"
                  value={inputValue}
                  onChange={(event: React.FormEvent<HTMLInputElement>) => {
                    inputOnChange(event.currentTarget.value, inputVariableName);
                  }}
                  disabled={disabledInput}
                  placeholder={placeholder}
                />
              </div>
              <div className="generalStyles__infoTooltipIconBlank" />
            </div>
          </div>
        </>
      )}
    </>
  );
}
